export const CSS = {
  toggle: "toggle",
  check: "check-svg",
};
